// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"48":"0cbcef77","76":"c62c74a7","223":"7349991f","232":"267767f5","329":"601eea94","366":"3ff1adb4","480":"e4bd8d2d","681":"dedf0288","787":"b75bed08","938":"9321229f","975":"0aae7608"}[chunkId] + ".chunk.js";
};